<template>
  <div class="flex flex-col">
    <div class="grow flex flex-col px-4 py-8">
      <div class="text-base text-gray-700 font-bold mb-4">
        <span v-if="!FMStore.isReschedule">
          You are about to book an appointment to replace your old meter
        </span>
        <span v-else>
          Your current appointment for the old meter exchange is scheduled for
        </span>
      </div>
      <div class="flex flex-col gap-2.5 mb-[40px]">
        <div class="grid grid-cols-[24px_1fr] gap-2 items-center text-base font-bold text-darkGrey ">
          <Icon icon="calendar"></Icon>
          <span>{{ FMStore.selectedDate }}</span>
        </div>
        <div class="grid grid-cols-[24px_1fr] gap-2 items-center text-base font-bold text-darkGrey ">
          <Icon icon="clock"></Icon>
          <template v-if="FMStore.selectedTimeSlot">
            <span>{{ getSlotTimeRangeById(FMStore.selectedTimeSlot) }}</span>
          </template>
          <template v-else>
            <span>
              {{ rescheduleTimeslot }}
            </span>
          </template>
        </div>
      </div>
      <template v-if="!FMStore.isReschedule">
      <div class="text-base text-gray-700 font-bold mb-4">
        Tell us about yourself
      </div>
      <div class="confirm ">

        <FormKit
            type="form"
            ref="contactForm"
            :actions="false"
            #default="{ state: { valid } }"
            @node="onFormNode"
        >
          <div class="content">
            <FormKit
                type="text"
                name="CustomerName"
                label="Your name"
                placeholder="Your name"
                validation="required"
            ></FormKit>
            <FormKit
                type="mask"
                name="CustomerPhone"
                label="Phone number"
                validation="required"
                inputmode="numeric"
                mask="+1 (###) ###-####"
                placeholder="xxx-xxx-xxxx"
            />
            <FormKit
                type="email"
                name="CustomerEmail"
                label="Email"
                placeholder="your@email.com"
                validation="email"
            />
            <div class="w-full">
              <FormKit
                  type="textarea"
                  name="CustomerNote"
                  label="Special requests"
                  placeholder="Anything you’d like the technician to know?"
                  v-model="message"
                  @input="updateCharCount"
                  maxlength="120"
                  :config="textareaOptions"
              ></FormKit>
              <div class="mb-4 text-xs text-grey-600">{{ charCount }}/120</div>
            </div>

            <FormKit
                type="checkbox"
                name="CustomerUpdate"
                label="Text me an appointment reminder"
                :value="true"
                :config="{
                    classes:{
                      outer:{
                        '!mb-2.5':true
                      },
                      wrapper:{
                        '!mb-0': true
                      }
                    }
                  }"
            >
            </FormKit>
            <FormKit
                type="checkbox"
                name="CustomerAge"
                label="I am 18 years or older"
                validation="accepted"
                validation-visibility="dirty"
            >
            </FormKit>
          </div>
        </FormKit>
      </div>
      </template>
      <template v-else>
        <div class="w-full flex flex-col gap-1.5">
        <Button class="btn btn__primary" @click="confirmRescheduleModalOpen = true">
          Reschedule
        </Button>
        <Button class="btn btn__link" @click="confirmCancelModalOpen = true">
          Cancel appointment
        </Button>
        </div>
      </template>
    </div>
    <Buttons>

      <template v-if="!FMStore.isReschedule">
        <Button class="btn btn__primary" :disabled="disabled" :loading="isLoading"
                @click="submitHandler">
          Confirm
        </Button>
      </template>

    </Buttons>

  </div>
  <Modal :is-open="confirmCancelModalOpen"
         title=" "
         @close="confirmCancelModalOpen = false">

    <div class="flex flex-col gap-4">
      <div class="text-base text-center text-[#141A1F] font-medium pb-[8px]">
        Are you sure you want to cancel your appointment?
      </div>
      <Button class="btn btn__orange" @click="cancelAppointment">
        Cancel appointment
      </Button>
      <Button class="btn btn__secondary" @click="confirmCancelModalOpen = false">
        Go back
      </Button>
    </div>
  </Modal>
  <Modal :is-open="confirmRescheduleModalOpen"
         title=" "
         @close="confirmRescheduleModalOpen = false">

    <div class="flex flex-col gap-4">
      <div class="text-base text-center text-[#141A1F] font-medium pb-[8px]">
        Are you sure you want to reschedule this appointment?
      </div>
      <Button class="btn btn__primary" @click="goToReschedule">
        Reschedule appointment
      </Button>
      <Button class="btn btn__secondary" @click="confirmRescheduleModalOpen = false">
        Go back
      </Button>
    </div>
  </Modal>
</template>

<script setup>
import {ref, watchEffect, computed} from "vue";
import {FormKit} from "@formkit/vue";
import {useFMStore} from "@/store/FMStore";
import Icon from "~/components/ui/Icon.vue";
import Button from "~/components/ui/Button.vue";
import Buttons from "~/components/ui/Buttons.vue";
import Modal from "~/components/ui/Modal.vue";
import Done from "~/components/Done.vue";
defineEmits(['start'])

defineProps({
  isLoading: Boolean
})
const FMStore = useFMStore();
const message = ref("");
const charCount = computed(() => message.value.length);
const contactForm = ref(null)
const isLoading = ref(false);
const disabled = ref(true);
const formNode = ref(null);
const confirmCancelModalOpen = ref(false);
const rescheduleTimeslot = ref('')
const confirmRescheduleModalOpen = ref(false);
function updateCharCount() {
  const charCount = message.value.length;
  console.log(charCount);
}

onMounted(() => {
  if (FMStore.isReschedule) {
    rescheduleTimeslot.value = `${formatUTCTimeOnly(FMStore.selectedWorkOrder?.AppointmentStartTime)} - ${formatUTCTimeOnly(FMStore.selectedWorkOrder?.AppointmentEndTime)}`
  }
})


const onFormNode = (node) => {
  formNode.value = node
}
watchEffect(() => {
  if (formNode.value?.context?.state) {
    disabled.value = !formNode.value.context.state.valid
  }
})

async function cancelAppointment() {
  try {
    confirmCancelModalOpen.value = false;
    await FMStore.cancelAppointment();
    FMStore.goToStep('Done');
    FMStore.showCancelMsg = true;

  } catch (e) {
    throw new Error('Error canceling appointment');
  }
}


function goToReschedule() {
  FMStore.goToStep('Selectdate');
  FMStore.isReschedule = false;
}

async function submitHandler(data) {
  isLoading.value = true;
  FMStore.loading = true;
  const formData = formNode.value?.context?.value || {};
  const {CustomerName, CustomerPhone, CustomerEmail, CustomerNote, CustomerUpdate, CustomerAge} = formData

  FMStore.customerData = {
    CustomerName,
    CustomerPhone,
    CustomerEmail,
    CustomerNote,
    CustomerUpdate,
    CustomerAge
  }
  try {
    await FMStore.createAppointment();
    FMStore.stepNumber = null;
    FMStore.goToStep('Done');
  } catch (error) {
    if (error.message?.includes('no longer available')) {
      FMStore.selectedTimeSlot = null;
      FMStore.goToStep('Selectdate');
    }
    // else: FMStore.error / errorMessage already set, stay on Confirm so the UI shows it
  } finally {
    isLoading.value = false;
    FMStore.loading = false;
  }
}

function getSlotTimeRangeById(slotId) {
  const slot = FMStore.openTimeSlots.find((slot) => String(slot.TimeSlotId) === String(slotId) && String(slot.TimeSlotStart).split('T')[0] === FMStore.selectedDate);

  if (!slot) {
    return null; // or handle the case where the slot is not found
  }

  return (
      formatUTCTimeOnly(slot.TimeSlotStart) +
      " and " +
      formatUTCTimeOnly(slot.TimeSlotEnd)
  );
}

function formatUTCTimeOnly(timestamp) {
  const date = new Date(timestamp);
  const hours = date.getUTCHours();
  const minutes = date.getUTCMinutes();
  const period = hours >= 12 ? "PM" : "AM";
  const formattedHours = hours % 12 || 12;
  const formattedMinutes = minutes.toString().padStart(2, "0");
  return `${formattedHours}:${formattedMinutes} ${period}`;
}

const textareaOptions = {
  classes: {
    input: {
      'h-[130px]': true,
      'resize-none': true,
      '!text-base': true,
    },
    inner:{
      'rounded-[6px]':true,
    },
    outer: {
      '!mb-1.5': true
    }

  }
}
</script>


